const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;

// Converts a plain address string (e.g. "Dallas, TX") into { lat, lng }
// using Mapbox's Geocoding API. Used since our loads store addresses
// as text, not coordinates — we need real coordinates to calculate
// distance/route ordering.
export async function geocodeAddress(address) {
  const encodedAddress = encodeURIComponent(address);
  const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodedAddress}.json?access_token=${MAPBOX_TOKEN}&limit=1`;

  const response = await fetch(url);
  const data = await response.json();

  if (data.features && data.features.length > 0) {
    const [lng, lat] = data.features[0].center; // Mapbox returns [lng, lat] order
    return { lat, lng };
  }

  return null;
}

// Straight-line distance between two coordinates, in miles.
// Used for ordering stops by proximity — doesn't need to be driving
// distance for the ORDERING decision itself, just relative closeness.
// (The actual displayed ROUTE still uses real driving directions.)
export function haversineDistance(coord1, coord2) {
  const toRad = (deg) => (deg * Math.PI) / 180;
  const R = 3958.8; // Earth's radius in miles

  const dLat = toRad(coord2.lat - coord1.lat);
  const dLng = toRad(coord2.lng - coord1.lng);

  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(coord1.lat)) * Math.cos(toRad(coord2.lat)) * Math.sin(dLng / 2) ** 2;

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}